import { Controller } from "@hotwired/stimulus";
import Tracker from "../../tracking/tracker";

// Main controller that handles tracking on all pages of the app
export default class extends Controller {
  static targets = ["userEmail", "userId", "intercomUserHash"];

  initialize() {
    this.tracker = new Tracker();

    this.identify();

    this.tracker.page(); // without this call, tracking won't work in Hubspot as Hubspot necessitate a page or track call after an identify one
  }

  identify() {
    if (!this.tracker.enabled()) return;

    if (!this._canTrack()) return;

    this.tracker.identify(this._identifyCallParams());
  }

  _canTrack() {
    return this.hasUserEmailTarget;
  }

  _identifyCallParams() {
    const params = {
      id: this.userIdTarget.dataset.value,
      email: this.userEmailTarget.dataset.value,
      tmpSegmentIntercomBugFakeAttr: "nonsense", // used to fix a bug that prevent users from being identified in Intercom
      intercomUserHash: this.hasIntercomUserHashTarget ? this.intercomUserHashTarget.dataset.value : null,
    };

    return params;
  }
}
